import service from '@/utils/request';

// @Summary 获取game列表
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /game/gameList [post]
export var getGameList = function getGameList(data) {
  return service({
    url: "/game/getGameList",
    method: 'post',
    data: data
  });
};

// @Summary 获取游戏权限
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /game/gameList [post]
export var getGameAuth = function getGameAuth(data) {
  return service({
    url: "/game/getGameAuth",
    method: 'post',
    data: data
  });
};

// @Summary 保存游戏权限
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /game/gameList [post]
export var saveGameAuth = function saveGameAuth(data) {
  return service({
    url: "/game/saveGameAuth",
    method: 'post',
    data: data
  });
};

// @Summary 保存游戏权限
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /game/gameList [post]
export var getBaseGameById = function getBaseGameById(game_id) {
  return service({
    url: "/game/getBaseGameById",
    method: 'post',
    data: {
      game_id: game_id
    }
  });
};
export var gameConfigSave = function gameConfigSave(data) {
  return service({
    url: "/game/gameConfigSave",
    method: 'post',
    data: data
  });
};